import { FormControlAccessComponent } from '@kalidea/kaligraphi';
import { Subject } from 'rxjs';
import { applyMixins } from 'src/app/_core/tools/apply-mixins';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';

/**
 * create custom FormControlAccessComponent merged with SubscriptionManager
 */

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CustomFormControlAccess extends SubscriptionManager {
}

export class CustomFormControlAccess extends FormControlAccessComponent {
    protected readonly closedSubject = new Subject<void>();
}

applyMixins(CustomFormControlAccess, [SubscriptionManager]);

/**
 * create custom FormControlAccessComponent merged with BaseComponent
 */

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CustomFormControlAccessWithLoaders extends FormControlAccessComponent {
}

export class CustomFormControlAccessWithLoaders extends BaseComponent {
    protected readonly closedSubject = new Subject<void>();

    /**
     * function called when control is changed
     */
    protected onChange: any = () => {
    };

    /**
     * function called when control is touched
     */
    protected onTouched: any = () => {
    };
}

applyMixins(CustomFormControlAccessWithLoaders, [BaseComponent, FormControlAccessComponent]);
